import axios from 'axios';
import {useQuery, useQueryClient} from 'react-query';
import {environment} from '../config/environment';
import {useRecoilValue} from "recoil";
import {latestBlockState} from "../state";

export const useLatestTxs = () => {
    const recoilLatestBlock = useRecoilValue(latestBlockState)

    const queryClient = useQueryClient();
    return useQuery(
        'latest-txs',
        () => axios.get(`${environment.apiBase}/tx/list?count=10`).then((res) => res.data),
        {
            retry: false,
            staleTime: 1000 * 60,
            refetchInterval: 1000 * 60,
            onSuccess: (data) => {
                // Update block
                Object.keys(data.payload).forEach((i) => {
                    const r = {type: 'tx', payload: data.payload[i]};
                    queryClient.setQueryData(['txdetail', '0x' + data.payload[i].hash], r);
                });

                // invalidate summary
                const latestTx = data.payload.at(0); // assuming sorted
                if (recoilLatestBlock.height === -1 || latestTx.blockheight > recoilLatestBlock.height) {
                    queryClient.invalidateQueries({queryKey: 'summary'})
                }
            },
        }
    );
};

export default useLatestTxs;
